exports.components = {
  "component---src-pages-imprint-js": () => import("./../../../src/pages/imprint.js" /* webpackChunkName: "component---src-pages-imprint-js" */),
  "component---src-pages-index-backup-js": () => import("./../../../src/pages/index_backup.js" /* webpackChunkName: "component---src-pages-index-backup-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-moonmic-js": () => import("./../../../src/pages/moonmic.js" /* webpackChunkName: "component---src-pages-moonmic-js" */)
}

